import React from 'react';
import { fieldCls } from './bbShared';

export const BLOCAGES = ['Commission / conditions', 'Technique / local', 'Décideur / enseigne', 'Concurrence'];
export const AIDES = ['Directeur commercial', 'DR', 'SAV', 'DSAO'];

export const AideFields = ({ v, set, fixed }) => (
  <div className={`rounded-xl border p-4 ${v.besoin_aide ? 'border-[#F4C3A1] bg-[#FDF1E8]' : 'border-[#E5E3DE]'}`}>
    {!fixed && (
      <label className="flex items-center gap-2 text-sm font-bold cursor-pointer mb-3">
        <input type="checkbox" checked={!!v.besoin_aide} onChange={e => set('besoin_aide', e.target.checked)} className="w-4 h-4 accent-[#F26A1B]" data-testid="bb-aide-toggle" />
        Besoin d'aide sur ce dossier
      </label>
    )}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div><p className="text-xs text-slate-500 mb-1">Type de blocage</p>
        <select className={fieldCls} value={v.besoin_aide_type || ''} onChange={e => set('besoin_aide_type', e.target.value)} disabled={!v.besoin_aide} data-testid="bb-aide-type">
          <option value="">Choisir…</option>{BLOCAGES.map(b => <option key={b}>{b}</option>)}
        </select></div>
      <div><p className="text-xs text-slate-500 mb-1">Aide attendue de</p>
        <select className={fieldCls} value={v.besoin_aide_qui || ''} onChange={e => set('besoin_aide_qui', e.target.value)} disabled={!v.besoin_aide} data-testid="bb-aide-qui">
          <option value="">Choisir…</option>{AIDES.map(b => <option key={b}>{b}</option>)}
        </select></div>
    </div>
    {v.besoin_aide && (
      <div className="mt-3"><p className="text-xs text-slate-500 mb-1">Commentaire</p>
        <textarea rows={2} className={fieldCls} value={v.besoin_aide_commentaire || ''} onChange={e => set('besoin_aide_commentaire', e.target.value)} data-testid="bb-aide-comment" /></div>
    )}
  </div>
);

